module.exports = __webpack_public_path__ + "71488dec2ecd597f7a9fe3fa7d2b7815.svg";